import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function PopularComics() {
  const popularComics = [...comics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 6);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            热门漫画
          </h2>
          <p className="text-sm text-foreground-500">
            千万读者的共同选择
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {popularComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-50/80 transition-colors cursor-pointer border border-background-200/70"
              data-product-shop
            >
              <div className="flex-shrink-0 w-20 md:w-24">
                <div className="aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                    title={`${comic.title} - 热门漫画 - 布丁漫画网`}
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold">
                      {index + 1}
                    </span>
                    <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                      {comic.title}
                    </h3>
                  </div>
                  <p className="text-xs text-foreground-500 mb-2">
                    {comic.author} · {comic.status === "ongoing" ? "连载中" : "已完结"}
                  </p>
                  <p className="text-xs text-foreground-600 line-clamp-2">
                    {comic.description}
                  </p>
                </div>
                <div className="flex items-center gap-4 text-xs text-foreground-500 mt-2">
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </div>
                    {(comic.views / 10000).toFixed(0)}万
                  </span>
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500"></i>
                    </div>
                    {comic.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}